import * as Flowbite from 'flowbite-react';
import { BaseInputProps } from '../types';
import { theme } from './theme';

type RadioProps<T = unknown> = BaseInputProps<T> & {
    option: T;
    description?: string;
};

export const Radio = <T = unknown,>({
    onChange = () => {},
    option,
    value,
    label,
    description,
    ...props
}: RadioProps<T>) => (
    <Flowbite.Label className="flex items-center gap-4" color={props.color}>
        <Flowbite.Radio
            {...props}
            theme={theme}
            checked={option === value}
            onChange={() => !props.readOnly && onChange(option)}
        />
        <div>
            <span className="block font-medium">{label}</span>
            {description && (
                <span className="text-gray-500 text-sm">{description}</span>
            )}
        </div>
    </Flowbite.Label>
);
